<form #form="ngForm" class="mei-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                MEI
            </h6>
            <p class="form-text text-muted">
                Dados do MEI (Microempreendedor Individual)
            </p>
        </div>  

        <div class="card-body" *ngIf="entity">
            <div class="row">
                <div class="form-group col-12">             
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.optanteMEI" name="optanteMEI" id="optanteMEI"
                            [disabled]="!canEdit" [readonly]="!canEdit">
                        <label class="custom-control-label" for="optanteMEI">
                            Optante pelo MEI?
                        </label>
                    </div>                    
                    <p class="form-text text-muted">
                        Marque esta opção se for optante pelo MEI
                    </p>                                           
                </div>                
            </div>
            <div class="row mei-datas">
                <div class="form-group col-12" [ngClass]="{'col-md': !isMini}"
                    *ngIf="canEdit || entity.optanteMEI">     
                    <label for="optanteMEIData" class="control-label">Data de Opção pelo MEI</label>
                    <ng-template [ngIf]="canEdit && entity.optanteMEI">
                        <sgt-datepicker [(ngModel)]="entity.optanteMEIData" name="optanteMEIData" id="optanteMEIData"
                            #optanteMEIData="ngModel" [ngControl]="optanteMEIData" #optanteMEIDataDatepicker
                            [required]="entity.optanteMEI">
                        </sgt-datepicker>
                        <sgt-form-control-error
                            *ngIf="optanteMEIData.errors && optanteMEIData.errors.required && optanteMEIData.dirty"
                            msgError="A data de opção pelo MEI é obrigatória">
                        </sgt-form-control-error> 
                    </ng-template>

                    <ng-template [ngIf]="!canEdit || !entity.optanteMEI">
                        <input type="text" class="form-control" [value]="entity.optanteMEIData | date:'dd/MM/yyyy'" name="optanteMEIData" id="optanteMEIData"
                            disabled="disabled" readonly="readonly">
                    </ng-template>

                    <p class="form-text text-muted">
                        Data em que a empresa optou pelo MEI
                    </p>
                </div>

                <div class="form-group col-12 col-md" [ngClass]="{'col-md': !isMini}"
                    *ngIf="canEdit || entity.optanteMEIDataExclusao">     
                    <label for="optanteMEIDataExclusao" class="control-label">Data de Exclusão do MEI</label>
                    <ng-template [ngIf]="canEdit">
                        <sgt-datepicker [(ngModel)]="entity.optanteMEIDataExclusao" name="optanteMEIDataExclusao" id="optanteMEIDataExclusao"
                            #optanteMEIDataExclusao="ngModel" [ngControl]="optanteMEIDataExclusao">
                        </sgt-datepicker>
                    </ng-template>

                    <ng-template [ngIf]="!canEdit">
                        <input type="text" class="form-control" [value]="entity.optanteMEIDataExclusao | date:'dd/MM/yyyy'" name="optanteMEIDataExclusao" id="optanteMEIDataExclusao"
                            disabled="disabled" readonly="readonly">
                    </ng-template>

                    <p class="form-text text-muted">
                        Data em que a empresa foi excluída do MEI
                    </p>                    
                </div>
            </div>
        </div>
    </div>
</form>